<div class="modal-body">
    <div class="alert alert-primary workflowPlaceholder border-primary text-body p-2" role="alert">
        <h6><strong translate="Settings.AccountSecuritySection.Dialog.SecurityKey"></strong></h6>
        <span class="lh-base" translate="Settings.AccountSecuritySection.Dialog.InformationSecurityKey"></span>
        <br /> <br />
        <a [href]="AuthenticationSecurityUrl" target="_blank" class="text-decoration-none" rel="noopener" translate>Settings.AccountSecuritySection.Dialog.MoreInformation</a>
    </div>

    <div class="col-12">
        <span class="lh-base" translate="Settings.AccountSecuritySection.Dialog.PlaceFidoU2FsecurityKey"></span>
    </div>
</div>


<div class="modal-footer border-top-active d-table w-100">
    <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close();" translate="Button.Back"></button></span>
</div>